import { useMemo, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { APPT_TYPES, TIMES } from "@/lib/format";
import { Btn, Chip, Field } from "@/components/rp";

const nextDays = () => {
  const out = [];
  for (let i = 1; i <= 14; i++) {
    const d = new Date();
    d.setDate(d.getDate() + i);
    if (d.getDay() !== 0) out.push(d);
  }
  return out;
};

const dayKey = (d) => d.toDateString();

export const BookingForm = ({ onBooked }) => {
  const days = useMemo(nextDays, []);
  const [type, setType] = useState("sopralluogo");
  const [day, setDay] = useState(null);
  const [time, setTime] = useState(null);
  const [title, setTitle] = useState("");
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!day || !time) return toast.error("Scegli giorno e orario");
    const [h, m] = time.split(":").map(Number);
    const d = new Date(day);
    d.setHours(h, m, 0, 0);
    setLoading(true);
    try {
      await api.post("/appointments", { title, type, date: d.toISOString(), duration_min: 60, location: "", notes });
      toast.success("Richiesta inviata! Ti confermeremo l'appuntamento a breve.");
      setDay(null); setTime(null); setTitle(""); setNotes("");
      onBooked?.();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-6" data-testid="booking-form">
      <div className="space-y-3">
        <p className="rp-label">Tipo</p>
        <div className="flex flex-wrap gap-2">{APPT_TYPES.map((t) => <Chip key={t.v} active={type === t.v} onClick={() => setType(t.v)} data-testid={`booking-type-${t.v}`}>{t.l}</Chip>)}</div>
      </div>
      <div className="space-y-3">
        <p className="rp-label">Giorno</p>
        <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1">
          {days.map((d, i) => (
            <button type="button" key={dayKey(d)} onClick={() => setDay(d)} data-testid={`booking-day-${i}`}
              className={`shrink-0 w-16 py-2.5 rounded-2xl text-center transition-colors ${day && dayKey(day) === dayKey(d) ? "bg-[#070707] text-white" : "bg-[#EBEBEB] hover:bg-[#E6DDCE]"}`}>
              <span className="block text-[11px] uppercase tracking-wider opacity-70">{d.toLocaleDateString("it-IT", { weekday: "short" })}</span>
              <span className="block text-lg font-semibold leading-tight">{d.getDate()}</span>
              <span className="block text-[11px] opacity-70">{d.toLocaleDateString("it-IT", { month: "short" })}</span>
            </button>
          ))}
        </div>
      </div>
      <div className="space-y-3">
        <p className="rp-label">Orario</p>
        <div className="flex flex-wrap gap-2">{TIMES.map((t) => <Chip key={t} active={time === t} onClick={() => setTime(t)} data-testid={`booking-time-chip-${t.replace(":", "")}`}>{t}</Chip>)}</div>
      </div>
      <Field label="Oggetto"><input value={title} onChange={(e) => setTitle(e.target.value)} className="rp-field" placeholder="es. Scelta piastrelle bagno" data-testid="booking-title-input" /></Field>
      <Field label="Note"><textarea rows={3} value={notes} onChange={(e) => setNotes(e.target.value)} className="rp-field" placeholder="Informazioni utili per lo staff" data-testid="booking-notes-input" /></Field>
      <Btn type="submit" loading={loading} data-testid="booking-submit-button">Richiedi appuntamento</Btn>
    </form>
  );
};
